var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1068)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.0752,
    y: 1.56055,
    width: 9.81445,
    height: 18,
    rx: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.63721C1.34315 8.63721 0 9.98035 0 11.6372V17.5605C0 19.2174 1.34315 20.5605 3 20.5605H17C18.6569 20.5605 20 19.2174 20 17.5605V11.6372C20 9.98035 18.6569 8.63721 17 8.63721H3ZM12.3938 13.3622C12.3938 14.2941 11.8613 15.1016 11.084 15.497V17.3677C11.084 17.92 10.6363 18.3677 10.084 18.3677H9.97852C9.42623 18.3677 8.97852 17.92 8.97852 17.3677V15.5275C8.16752 15.1442 7.60645 14.3187 7.60645 13.3622C7.60645 12.0402 8.67813 10.9685 10.0001 10.9685C11.3221 10.9685 12.3938 12.0402 12.3938 13.3622Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.560547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlack);
export default __webpack_public_path__ + "static/media/lock_black.92b671d671aef981a3cf7c42484b21f8.svg";
export { ForwardRef as ReactComponent };